import React from 'react';
import { Typography } from 'helpers/themeSafeMui.helper';

const GoogleAuthCallback = () => {
  return <Typography>Redirecting...</Typography>;
};

export default GoogleAuthCallback;
